<template>
  <div>
    <div class="mask-container" v-if="showBtn">
      <div class="mask"></div>
      <div class="btn" @click="goLogin">点击手机扫码登录查看详情</div>
    </div>
    <Modal
      :title="title"
      :closeBtn="closeBtn"
      width="400px"
      v-if="showModal"
      @close="cancelModal"
    >
      <div slot="body" class="model-container">
        <img v-if="islogo" class="logo" src="./../assets/tc_1.png" />
        <div
          v-if="env"
          style="font-size: 24px; color: red; margin-bottom: 10px"
        >
          {{ env }}
        </div>
        <div class="qrcode-container">
          <img :src="qrcode" class="qrcode" />
          <!-- <div class="qrcode-container-mask"></div> -->
        </div>
        <div class="flex-middle" style="margin: 15px 0 25px 0">
          <img src="./../assets/wechat.png" />
          <div class="scon-test">使用微信“扫一扫”功能扫码登录</div>
        </div>
        <!-- <div>手机扫描二维码前往授权登录</div> -->
        <div class="qrcode-tip justify-center flex-column">
          <div>如小程序授权登录不成功</div>
          <div>
            请点击
            <a-button
              type="link"
              :disabled="isRefreshDisabled"
              icon="sync"
              style="padding: 0; height: 18px"
              @click="refresh"
            >
              {{ isRefreshDisabled ? `刷新(${countDown}s)` : "刷新" }}
            </a-button>
            重新扫码登录
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as api from '@/api'
import Modal from '@/components/Modal.vue'
import Vue from 'vue'
import { mapState } from 'vuex'
export default {
  name: 'ProductMask',
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      default: '扫码登录'
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    successCallback: {
      type: Function,
      default: null
    },
    closeBtn: {
      type: Boolean,
      default: true
    },
    islogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

      showModal: false,
      qrcode: '',
      scene: '',
      lockReconnect: false,
      timer: null,
      count: 0,
      isRefreshDisabled: false,
      countDown: 5
    }
  },
  computed: {
    ...mapState({
      currentCountry: state => state.currentCountry
    }),
    env() {
      let env = process.env.VUE_APP_ENV
      switch (env) {
        case 'development': return '开发环境，内部测试用'
        case 'test': return 'test环境，内部测试用'
        case 'uat': return 'uat环境，内部测试用'
        default: return false
      }
    }
  },
  methods: {
    refresh() {
      if (this.isRefreshDisabled) {
        return;
      }

      this.isRefreshDisabled = true;
      this.fetchQRCode().finally(() => {
        this.countDown = 5;

        // 开始倒计时
        const countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown <= 0) {
            clearInterval(countDownTimer);
            this.isRefreshDisabled = false;
          }
        }, 1000);
      });
    },
    fetchQRCode() {
      this.$loading(true)
      return api.fetchQRCode({ country: this.currentCountry?.tenantId || 1000 }).then(res => {
        if (res.success) {
          const { result = {} } = res
          const { qrcode, scene } = result
          this.qrcode = qrcode
          this.scene = scene
          this.$nextTick(() => {
            this.initWebSocket()
          })
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.$loading(false)
      })
    },
    initWebSocket: function () {
      if (typeof WebSocket === 'undefined') {
        this.$message.error('当前浏览器不支持WebSocket')
      } else {
        console.log('------------WebSocket连接成功')
        const url = window._CONFIG.systemURL.replace('https://', 'wss://').replace('http://', 'ws://') + '/messageWebsocket/' + this.scene
        // update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websock = new WebSocket(url)
        // update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websock.onopen = this.websocketOnopen
        this.websock.onerror = this.websocketOnerror
        this.websock.onmessage = this.websocketOnmessage
        this.websock.onclose = this.websocketOnclose
      }
    },
    websocketOnopen: function () {
      console.log('WebSocket连接成功')
      // const that = this
      // // 模拟心跳
      // this.timer = setInterval(() => {
      //   that.websocketSend('HeartBeat')
      // }, 20000)
    },
    websocketOnerror: function (e) {
      console.log('WebSocket连接发生错误')
      this.reconnect()
    },
    websocketOnmessage: function (e) {
      console.log('-----接收消息-------', e.data)
      /* eslint-disable no-eval */
      if (e.data) {
        this.$store.commit('SET_TOKEN', e.data)
        this.isInnerUser()
      }
      // clearInterval(this.timer)
      // // 关闭socket
      // this.websock.close()
      //  location.reload()
    },
    websocketOnclose: function (e) {
      console.log('connection closed (' + e + ')')
      if (e) {
        console.log('connection closed ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
      }
      this.reconnect()
    },
    //获取是否是内部员工
    isInnerUser() {
      api.checkUser().then(res => {
        if (res.success) {
          console.log("res============", res)
          this.$store.commit('SET_INNER', res.result)
          if (typeof this.successCallback === 'function') {
            this.successCallback()
            return
          }
          location.reload()
        }
      })
    },
    reconnect() {
      const that = this
      if (that.lockReconnect) return
      that.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info('尝试重连...')
        that.initWebSocket()
        that.lockReconnect = false
      }, 20000)
    },
    websocketSend(text) { // 数据发送
      try {
        this.websock.send(text)
      } catch (err) {
        console.log('send failed (' + err.code + ')')
      }
    },
    goLogin() {
      this.isRefreshDisabled = true;
      this.fetchQRCode().then(() => {
        this.showModal = true;
        // 获取二维码后立即开始倒计时
        this.countDown = 5;
        const countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown <= 0) {
            clearInterval(countDownTimer);
            this.isRefreshDisabled = false;
          }
        }, 1000);
      }).catch(e => {
        if (e.code === 500 && e.message === '调用小程序生成二维码失败!' && this.count < 1) {
          this.count++;
          setTimeout(() => {
            this.goLogin();
          }, 1000);
        }
      });
    },
    cancelModal() {
      this.showModal = false
    }
  }
}
</script>

<style scoped lang="less">
.mask-container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.7) 0%,
    #ffffff 100%
  );
}
.model-container {
  padding: 20px;
  padding-top: 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  .logo {
    position: absolute;
    top: -145px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 72px;
    height: 113px;
  }
}
.btn {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  width: 384px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  font-weight: 600;
  border: 1px #ccc solid;
  font-weight: 400;
  color: #333;
  font-size: 16px;
  cursor: pointer;
}
.qrcode-container {
  position: relative;
  width: 200px;
  height: 200px;
  margin: auto;
}
.scon-test {
  font-weight: 400;
  font-size: 14px;
  color: #000;
  margin-left: 5px;
}
.qrcode {
  width: 100%;
  height: 100%;
}
.qrcode-container-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
}
.qrcode-tip {
  height: 70px;
  background: #f3f5f9;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
